import React, { useState } from 'react';
import { withRouter } from 'react-router';
import ROUTES from 'routes.json';
import styles from './Mfa.module.scss';
import { LoginLayout } from '../../layouts';
import { ErrorLabel, RouterLink } from '../../components';
import { Grid, Form } from '@solarwindscloud/cloud-ui';
import { LoginButton } from '../Login/left-side/form/components';
import { redirectTo } from '../../utils/utils';
import { ErrorMessage } from '../../components/ErrorMessage';
import { Input } from '@solarwindscloud/cloud-ui';
import { loginWithMfa } from '../../api/actions';
import { translateErrorCodeToMessage } from '../../utils/translateErrorCode/translateErrorCode';

export const Mfa = () => {
  return (
    <div data-test-page-name="mfa-login">
      <LoginLayout LeftSidePanel={withRouter(MfaLeftSide)} />
    </div>
  );
};

const EMPTY_ERROR_STATE = {
  email: '',
  loginError: '',
  ttl: '',
};

export function MfaLeftSide() {
  return (
    <>
      <MFAForm />
      <Grid padded verticalAlign="middle">
        <Grid.Column width={16} textAlign="center">
          {renderBackLink()}
        </Grid.Column>
      </Grid>
    </>
  );

  function renderBackLink() {
    return (
      <p data-test-block="backLink">
        <RouterLink data-test-link="backLink" to={ROUTES.LOGIN}>
          <b>Return to login screen</b>
        </RouterLink>
      </p>
    );
  }
}

export function MFAForm() {
  const [code, setCode] = useState('');
  const [showError, setShowError] = useState(false);
  const [loginError, setLoginError] = useState(EMPTY_ERROR_STATE);
  const [loading, setLoading] = useState(false);
  return (
    <>
      <div className={styles.twoFactorText}>
        <div className={styles.twoFactorTitle}>Two-factor authentication</div>
        <div className={styles.twoFactorDescription}>
          Enter the twofactor authentication code provided by the Authenticator app
        </div>
      </div>
      <Form
        className={styles.mfaForm}
        onSubmit={mfaLogin}
        method="POST"
        error={!isLoginValid()}
        data-test-mfa-login-form
      >
        <Grid padded verticalAlign="middle">
          <Grid.Column width={16}>
            {loginError.loginError && <ErrorMessage message={translateErrorCodeToMessage(loginError, 'MFA')} />}
            {renderCodeInput()}
            <LoginButton className={styles.loginButton} disabled={!isLoginValid()} loading={loading}>
              Log in
            </LoginButton>
          </Grid.Column>
        </Grid>
      </Form>
    </>
  );

  function renderCodeInput() {
    return (
      <div className={styles.codeInput}>
        <Form.Field error={showError} required>
          <Input
            icon="locked"
            iconPosition="left"
            name="code"
            aria-label="code"
            onChange={handleChangeCode}
            onBlur={handleOnBlur}
            placeholder="6-digit-code"
            required
            value={code}
            type="number"
            data-test-code-input
          />
        </Form.Field>
        {showError && <ErrorLabel data-test-error-label>Enter a valid code</ErrorLabel>}
      </div>
    );
  }

  function handleChangeCode(event, data) {
    setLoginError(EMPTY_ERROR_STATE);
    setShowError(false);
    if (data.value.length <= 6) {
      setCode(data.value);
    }
  }

  function isCodeValid() {
    return code.length === 6;
  }

  function isLoginValid() {
    return isCodeValid() && !loginError.loginError;
  }

  function handleOnBlur() {
    setShowError(!isCodeValid() && code.length !== 0);
  }

  async function mfaLogin() {
    try {
      setLoading(true);
      const redirectUri = await loginWithMfa(code);
      redirectTo(redirectUri);
    } catch (e) {
      setCode('');
      setLoading(false);
      setLoginError({ ...loginError, loginError: e.message, ttl: e.ttl || '' });
    }
  }
}
